import { render, staticRenderFns } from "./AccordionContent.vue?vue&type=template&id=724e0aa8&scoped=true&"
import script from "./AccordionContent.vue?vue&type=script&lang=js&"
export * from "./AccordionContent.vue?vue&type=script&lang=js&"
import style0 from "./AccordionContent.vue?vue&type=style&index=0&id=724e0aa8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "724e0aa8",
  null
  
)

export default component.exports